import { ShieldCheck } from "lucide-react";
import { useTranslation } from "react-i18next";

export const HKBadge = ({ className = "" }) => {
  const { t } = useTranslation();
  return (
    <span
      data-testid="hk-incorporated-compliance-badge"
      className={`inline-flex items-center gap-2 rounded-full border border-emerald-200 bg-emerald-50 px-3 py-1 text-xs font-semibold text-emerald-800 ${className}`}
    >
      <ShieldCheck className="h-4 w-4" />
      {t("brand.complianceLine")}
    </span>
  );
};
